import {
  GET_SCREENERS_TOP_UP_ITEMS
} from "@actions/utils/items"

import { get } from "@api/fetch"

export const getScreenerTopUpItems = () => dispatch => {
  dispatch(get(GET_SCREENERS_TOP_UP_ITEMS, "items/getItemsByCodes?codes=screeners_top_up"))
}